import { t } from "../../services/translation.service";
import Storage from "../../services/storage.service";
import { getFlowStatus } from "../../services/user.service";
import { clearError } from "../../services/errors.service";
import {
	getRecommendedRoute,
	goToRouteWithChecks,
} from "../../services/flow.service";
import Subscriber from "../../subscriber.class";
import React from "react";
import { generalEvent } from "../../services/tracking.service";

export default class Error extends Subscriber {
	componentDidMount() {
		this.subscriptions.push(
			Storage.get_obsrv("ok_clear_error_redirect").subscribe((data) => {
				if (data) {
					clearError();
					let recommended = getRecommendedRoute("ok_clear_error_redirect");
					goToRouteWithChecks(recommended);
				}
			})
		);

		this.subscriptions.push(
			Storage.get_obsrv("ok_clear_error_get_status").subscribe((data) => {
				if (data) {
					getFlowStatus("ok_clear_error_get_status")
						.then((response) => {
							clearError();
							let recommended = getRecommendedRoute(
								"ok_clear_error_get_status"
							);
							goToRouteWithChecks(recommended);
						})
						.catch((error) => {
							//handleError(true, "flowStatus ok_clear_error_get_status");
						});
				}
			})
		);
		this.subscriptions.push(
			Storage.get_obsrv("ok_clear_error").subscribe((data) => {
				if (data) {
					clearError();
				}
			})
		);
		this.subscriptions.push(
			Storage.get_obsrv("account_activated").subscribe((data) => {
				if (data) {
					clearError();
				}
			})
		);
	}

	setErrorAction = (error_button) => {
		Storage.set(error_button, true);
		if(error_button === "change_card") {
			clearError();
		}
	};

	getButton = (
		key,
		style = "vmo-button vmo-button-round vmo-button-wide vmo-button-red"
	) => {
		const { button_text } = this.props.error;

		let text =
			t("ERROR_BUTTON_" + key.toUpperCase()) ||
			t(button_text) ||
			t("ERROR_BUTTON_OK_CLEAR_ERROR");

			return (
			<button
				key={key}
				className={style}
				onClick={() => {
					this.setErrorAction(key);
					let eventObj = {
						eventCustomName : "error_occurred",
						extra_obj : {
							error_name: this.props.error.text,
							error_type: this.props.error.key,
							error_code : this.props.error.code,
							error_message:  this.props.error.text
						}
				}
				generalEvent(eventObj);
				}
			}
			>
				{text}
			</button>
		);
	};

	render() {
		let props = this.props;

		if (props.error) {
			let error_ctas = [
				"retry_payment",
				"continue_payment",
				"change_card",
				"start_chat",
				"ok_clear_error",
				"ok_clear_error_redirect",
				"ok_clear_error_get_status",
				"reset_mnp",
				"account_activated",
			];

			let buttons = [];

			let ctas = [];

			if (props.error.ctas) {
				ctas = props.error.ctas;
			}

			let in_modal = true;
			if (props.disable_modal) {
				in_modal = false;
			}

			if (ctas.length === 0 && props.error.key !== "error_fatal") {
				ctas = ["ok_clear_error_redirect"];
			}

			for (let cta_index in ctas) {
				let cta = ctas[cta_index];
				let style =
					"vmo-button vmo-button-round vmo-button-wide vmo-button-red";
				if (cta_index > 0) {
					style =
						"vmo-button vmo-button-round vmo-button-wide vmo-button-white";
				}
				if (error_ctas.indexOf(cta) !== -1) {
					buttons.push(this.getButton(cta, style));
				}
			}

			if (in_modal) {
				return (
					<div className="vmo-modal">
						<div className="vmo-modal-centered-small">
							<div className="vmo-modal-inner">
								<div className="vmo-modal-message vmo-with-icon">
									<h2>{t(props.error.title)}</h2>
									<p>{t(props.error.text)}</p>
									<br />
									{props.error.code ? (
										<>
											<p>Code: {props.error.code}</p>
										</>
									) : (
										""
									)}
								</div>
								<div className="vmo-modal-actions">{buttons}</div>
							</div>
						</div>
					</div>
				);
			} else {
				return (
					<>
						<div className="vmo-modal-message vmo-with-icon">
							<h2>{t(props.error.title)}</h2>
							<p>{t(props.error.text)}</p>
							<br />
							{props.error.code ? (
								<>
									<p>Code: {props.error.code}</p>
								</>
							) : (
								""
							)}
						</div>
						<div className="vmo-modal-actions">{buttons}</div>
					</>
				);
			}
		}
		return "";
	}
}
